import { HashRouter, Switch, Route } from 'react-router-dom';
import React from 'react';
import SubmenuSidebar from '../../../../global/submenu-sidebar/SubmenuSidebar';
import TerminologyTable from '../terminology-table/TerminologyTable';
import CsvUpload from '../csv-upload/CsvUpload';
import EmptyComponent from '../../../../global/empty-component/EmptyComponent';

const items = [
  { title: 'Browse Entries', href: '/terminology-data/browse', component: TerminologyTable },
  { title: 'CSV Upload', href: '/terminology-data/upload', component: CsvUpload },
];

const App = () => (
  <HashRouter>
    <div className="d-flex h-100">
      <SubmenuSidebar title="Terminology Data" linkItems={items} reloadingDataAllowed={false} />
      <div className="d-flex flex-column p-1 overflow-scroll flex-grow-1">
        <Switch>
          <Route exact path="/terminology-data" component={EmptyComponent} />
          {items.map(item => (
            <Route key={item.title} path={item.href} component={item.component} />
          ))}
        </Switch>
      </div>
    </div>
  </HashRouter>
);

export default App;
